import React from "react";
import Noc from "components/presentation/Noc";
import Competitor from "components/presentation/Competitor";
import Card from 'react-bootstrap/Card';
import Label from "components/general/Label";
import { isMoreStartListStatus } from "helpers/status";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faCamera} from "@fortawesome/free-solid-svg-icons";
import { useViewport } from 'components/general/useViewPort';

export function CompetitorBlock(competitor) {
    const { breakPoint } = useViewport();
    const responsive = breakPoint === "sm" || breakPoint === "xs"
    const resultStatus = competitor?.result?.status?.code
    var colour = ''
    switch(competitor?.resultItem?.startOrder){
      case 'b':
        colour = 'bg-blue';
        break;
      case 'g': 
        colour = 'bg-green';
        break;
      case 'r':
        colour = 'bg-red';
        break;
      case 'y':
        colour = 'bg-yellow';
        break;
    }

    var resultDataText = ''
    var hastPhoto = false
    if (competitor?.resultItem?.resultDataText){
        resultDataText = JSON.parse(competitor?.resultItem?.resultDataText)
        hastPhoto = resultDataText?.extra?.hasPhotofinish === 'true'
    }

    console.log(responsive)

        return (
            <div className="d-flex justify-content-start w-70">
            {isMoreStartListStatus(resultStatus) &&
                <div className={responsive ? `w-20 text-end px-1` : `w-10 text-end px-1`}>
                { hastPhoto
                    ? <FontAwesomeIcon className="font-icon" icon={faCamera} /> 
                    : competitor?.resultItem?.resultRank
                }
                </div>
            }
                <div className={responsive ? `w-20 text-center px-1 ${colour}` : `w-10 text-center px-1 ${colour}`}>
                    {competitor?.resultItem?.bib}
                </div>
                &nbsp;
                {responsive
                    ? ''
                    :
                    <>
                    <div className='w-30'>
                        <Noc className='mx-1' {...competitor?.participant?.organisation} />
                    </div>
                    </>
                }
                <div className={isMoreStartListStatus(resultStatus) ? "w-50" : "70"}>
                    <Competitor  {...competitor?.participant} hideNoc={responsive ? false : true} hidePicture={true} noLink={true} />
                </div>
            </div>
        )
}

export function Header({ data, bracket, phase }) {
    return (
        <Card.Header>
            <div className='score-header'>
                <span>{data?.eventUnit?.shortDescription}</span>
            </div>
        </Card.Header>
    )
}

export function CompetitorHeader({ data, bracket, phase }) {
    const resultStatus = data?.result?.status?.code
    return (
        <div className="d-flex">
        {isMoreStartListStatus(resultStatus) &&
            <div className="w-9 text-end px-1 fw-bold"><Label data="HeaderRk"/></div>
        }            
            <div className="w-9 text-end px-1 fw-bold"><Label data="HeaderBib"/></div>
            <div className={`${isMoreStartListStatus(resultStatus) ? "w-88" : "w-91"} text-start px-1 fw-bold`}><Label data="HeaderName"/></div>
        </div>
    )
}